import React, {useState, useEffect} from 'react'
import {Row, Col, Image, ProgressBar} from 'react-bootstrap';
import {firebase} from "../../firebase/firebaseConfig";

export default function UserAwards(props) {
  const [levelIcon, setLevelIcons] = useState(null);
  const storage = firebase.storage();

  let level = 10;
  for (let lvl in levels) {
    if (props.numberPoints < levels[lvl]) {
      level = (parseInt(lvl, 10) - 1);
      break;
    }
  }
  let progress = Math.round((props.numberPoints - levels[level.toString()]) / (levels[(level+1).toString()] - levels[level.toString()]) * 100);
  const pathRef = storage.ref('levelIcons/' + imageReferences[level.toString()]);

  useEffect(() => {
    pathRef.getDownloadURL()
      .then((url) => setLevelIcons(url))
      .catch((error) => console.error(error.code, error.message));
  }, [props.numberPoints])

  return (
    <Row className="mx-0">
      <Col xs={12} className="user-awards text-center mt-2">
        <h5 className="font-weight-bold text-left">Awards</h5>
        <Image src={levelIcon} roundedCircle />
        <ProgressBar striped variant="success" now={level === 10 ? 100 : progress} label={level === 10 ? "100%" :`${progress}%`} className="mx-4 mt-2"/>
        <p><strong>Level {level}:</strong> {levelNames[level.toString()]}. {`${props.numberPoints} points`}</p>
        <p className="stat text-left mt-4 pt-2"><strong>Posts: </strong>{props.numberPosts}</p>
        <p className="stat text-left"><strong>Comments: </strong>{props.numberComments}</p>
        <p className="stat text-left"><strong>Upvotes Received: </strong>{props.upvotesReceived}</p>
      </Col>
    </Row>
  )
}

const levels = {
  "1": 0,
  "2": 50,
  "3": 100,
  "4": 250,
  "5": 500,
  "6": 1000,
  "7": 2500,
  "8": 5000,
  "9": 7500,
  "10": 10000
};

const levelNames = {
  "1": "Curious",
  "2": "Wanderer",
  "3": "Traveler",
  "4": "Scout",
  "5": "Ranger",
  "6": "Explorer",
  "7": "Adventurer",
  "8": "Voyager",
  "9": "Pioneer",
  "10": "Globetrotter"
}

const imageReferences = {
  "1": "curious-min.png",
  "2": "wanderer-min.png",
  "3": "traveler-min.png",
  "4": "scout-min.png",
  "5": "ranger-min.png",
  "6": "explorer-min.png",
  "7": "adventurer-min.png",
  "8": "voyager-min.png",
  "9": "pioneer-min.png",
  "10": "globetrotter-min.png"
}